import { css } from '@emotion/react';
import styled from '@emotion/styled';
import BlockContent from '@sanity/block-content-to-react';
import xw from 'xwind';

export const BlockRender = styled(BlockContent)`
  @media (max-width: 640px) {
    font-size: 80%;
  }
`;

export const Anchor = styled.span`
  color: #5fa3a9;
  text-decoration: underline;
  cursor: pointer;
`;

export const H1 = styled.h1(
  xw`mb-2 mt-4 sm:mb-7 mt-10 mr-0 ml-0 font-bold`,
  css`
    &:first-child {
      margin-top: 0;
    }

    font-size: 34px;
    line-height: 50px;

    @media (max-width: 768px) {
      font-size: 24px;
      line-height: 30px;
    }
  `,
);

export const H2 = styled.h2(
  xw`mb-2 mt-4 sm:mb-7 mt-10 mr-0 ml-0 font-bold`,
  css`
    &:first-child {
      margin-top: 0;
    }

    font-size: 30px;
    line-height: 40px;

    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 24px;
    }
  `,
);

export const H3 = styled.h3(
  xw`mb-2 mt-4 sm:mb-7 mt-10 mr-0 ml-0 font-bold`,
  css`
    &:first-child {
      margin-top: 0;
    }

    font-size: 24px;
    line-height: 40px;

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 24px;
    }
  `,
);

export const H4 = styled.h4(
  xw`mb-2 mt-4 sm:mb-7 mt-10 mr-0 ml-0 font-bold`,
  css`
    &:first-child {
      margin-top: 0;
    }

    font-size: 1.25em;
    line-height: 1.25em;
  `,
);

export const H5 = styled.h5(
  xw`mb-2 mt-4 sm:mb-7 mt-10 mr-0 ml-0  font-bold`,
  css`
    &:first-child {
      margin-top: 0;
    }

    font-size: 1em;
    line-height: 1.25em;
  `,
);

export const H6 = styled.h6(
  xw`mb-2 mt-4 sm:mb-7 mt-10 mr-0 ml-0 font-bold`,
  css`
    line-height: 1.25em;

    &:first-child {
      margin-top: 0;
    }

    font-size: 0.875em;
  `,
);

export const Paragrahp = styled.p(
  xw`my-2 sm:my-7 mr-0 ml-0`,
  css`
    &:first-child {
      margin-top: 0;
    }

    font-size: 20px;
    line-height: 40px;

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 24px;
    }
  `,
);

export const UL = styled.ul(
  xw`my-2 sm:my-7 ml-8 list-disc`,
  css`
    &:first-child {
      margin-top: 0;
    }

    font-size: 20px;
    line-height: 40px;

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 24px;
    }
  `,
);

export const OL = styled.ol(
  xw`my-2 sm:my-7 ml-8 list-decimal`,
  css`
    &:first-child {
      margin-top: 0;
    }

    font-size: 20px;
    line-height: 40px;

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 24px;
    }
  `,
);

export const ListItem = styled.li(
  xw`pl-2`,
  css`
    &:first-child {
      margin-top: 0;
    }

    font-size: 20px;
    line-height: 40px;

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 24px;
    }
  `,
);
